import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'common/components/Icon';
import Typography from 'common/components/Typography';
import TextBox from 'common/components/TextBox';
import { Dropdown } from 'common/components/Dropdown';
import Checkbox from 'common/components/Checkbox';
import Button from 'common/components/Button';
import colors from 'common/styles/colors';

import { NETWORK_OPTIONS } from '../constants';
import ErrorBanner from './ErrorBanner';
import styles from './WalletInputStep.module.css';

const WalletInputStep = ({
  walletAddress,
  network,
  isConfirmed,
  isSubmitting,
  error,
  onWalletAddressChange,
  onNetworkChange,
  onConfirmationChange,
  onSubmit,
}) => {
  const isFormValid =
    walletAddress.trim() !== '' && network !== '' && isConfirmed && !isSubmitting;

  return (
    <div className={styles.form}>
      <div className={styles.infoSection}>
        <div className={styles.infoHeader}>
          <Icon.WalletDuotone
            description="Wallet"
            size="medium"
            fill={colors['rebranding-md-color-brand-purple']}
          />
          <Typography
            tag="span"
            size="base"
            weight="semiBold"
            color="color-neutral-900"
          >
            Wallet address
          </Typography>
        </div>
        <Typography tag="p" size="xs" color="color-neutral-500">
          Rewards will be transferred to the address you provide. Make sure the
          wallet provided supports the selected network.
        </Typography>
      </div>

      <TextBox
        name="walletAddress"
        placeholder="Wallet address"
        value={walletAddress}
        onChange={onWalletAddressChange}
        full
      />

      <Dropdown
        name="network"
        placeholder="Network"
        items={NETWORK_OPTIONS}
        initialSelectedItem={network}
        onChange={onNetworkChange}
      />

      <Checkbox
        id="withdraw-confirmation"
        name="withdraw-confirmation"
        label="I declare this wallet is mine and valid"
        value={isConfirmed}
        onChange={onConfirmationChange}
      />

      {error && (
        <ErrorBanner
          message="Something went wrong. Please try again."
          data-test="wallet-screening-error"
        />
      )}

      <Button kind="primary" full disabled={!isFormValid} onClick={onSubmit}>
        <button type="button" disabled={!isFormValid} data-test="wallet-continue-button">
          {isSubmitting ? 'Screening wallet...' : 'Continue'}
        </button>
      </Button>
    </div>
  );
};

WalletInputStep.propTypes = {
  walletAddress: PropTypes.string.isRequired,
  network: PropTypes.string.isRequired,
  isConfirmed: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onWalletAddressChange: PropTypes.func.isRequired,
  onNetworkChange: PropTypes.func.isRequired,
  onConfirmationChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

WalletInputStep.defaultProps = {
  isSubmitting: false,
  error: null,
};

export default WalletInputStep;
